import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/icons/arrow-left-eoi-request.svg'


const _hoisted_1 = {
  key: 0,
  class: "layout-eoi"
}
const _hoisted_2 = {
  key: 0,
  class: "wrapper container"
}
const _hoisted_3 = {
  key: 1,
  class: "wrapper flex container"
}
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.estate._id && $setup.isLotStatusAvailable)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode($setup["HeaderCustomer"], {
          estate: $setup.estate,
          hideAuthButtons: !$setup.isLogged()
        }, null, 8, ["estate", "hideAuthButtons"]),
        _createElementVNode("div", {
          class: "wrapper header container",
          id: "header-title"
        }, [
          _createElementVNode("div", { class: "link-back" }, [
            _createElementVNode("a", {
              class: "back",
              onClick: $setup.onBack
            }, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "EOI Request"
              }, null, -1),
              _createTextVNode("Contract Information Form", -1)
            ]))])
          ])
        ]),
        ($setup.isCreateEioError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("div", { class: "customer-error-block" }, "Something went wrong. Please contact support", -1)
            ]))]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode($setup["EOIRequestForm"], {
                estateId: $setup.estateId,
                stageId: $setup.stageId,
                lotId: $setup.lotId,
                businessId: $setup.businessId,
                eoiId: _ctx.eoiId,
                "onUpdate:isCreateEioError": $setup.updateIsCreateEoiError
              }, null, 8, ["estateId", "stageId", "lotId", "businessId", "eoiId"])
            ]))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4))
}